<template>
  <div id='toast-manager' aria-live="assertive" class="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6 z-50">
    <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
      <Component v-for='toast in toasts' :is='toast.getComponent()' :controller='toast.getController()' />
    </div>
  </div>
</template>

<script setup>

import { computed } from 'vue';

import { useToastManager } from '@/kernel/managers/toast-manager';

const toastManager = useToastManager();

const state = toastManager.getState();

const toasts = computed(() => {
  return Object.values(state.toasts);
});

</script>